const initialState = [];

export default (state = initialState, action) => {
  const { type: actionType, payload } = action;

  switch (actionType) {
    case 'sites/LOAD':
      return payload;
    case 'sites/ADD':
      return [...state, payload];
    case 'sites/UPDATE':
      return state.map((site) => (
        site._id === payload._id
          ? payload
          : site
      ));
    case 'sites/DELETE':
      return state.filter((site) => site._id !== payload);
    case 'sites/CLEAR':
      return initialState;
    default:
      return state;
  }
};
